export const typeIconMap: { [key in server.dto.AppointmentTypes]: string } = {
  accommodation: "icon-accommodation",
  show: "icon-show",
  train: "icon-train",
  flight: "icon-flight",
  externalCalendar: "icon-external",
  groundTransport: "icon-groundtransport",
  unknown: ""
};

export const phaseIconMap: { [key in server.dto.AppointmentPhases]: string } = {
  cancelled: "icon-cancelled",
  confirmed: "icon-confirmed",
  option: "icon-option",
  unknown: ""
};

export const getId = (appointment: server.dto.PlannerAppointment): string => {
  if (appointment.showId) { return appointment.showId.toString(); }
  if (appointment.trainSegmentId) { return appointment.trainSegmentId.toString(); }
  if (appointment.flightSegmentId) { return appointment.flightSegmentId.toString(); }
  if (appointment.groundTransportId) { return appointment.groundTransportId.toString(); }
  if (appointment.externalEventId) { return appointment.externalEventId.toString(); }

  throw new Error(`Unknown appointment type: ${JSON.stringify(appointment)}`);
};

export const canLinkAppointment = (
  canLinkUnlinkTravel: boolean,
  canLinkUnlinkShow: boolean,
  item: ItinerarySidebarItem,
  appointment: server.dto.PlannerAppointment
): boolean => {
  if (appointment.phase === "cancelled") {
    return false;
  }

  if (!item.itemId) {
    return false;
  }

  if (item.type === "show") {
    return canLinkToShow(canLinkUnlinkTravel, appointment);
  }

  return canLinkToTravel(canLinkUnlinkShow, appointment);
}

const canLinkToTravel = (canLinkUnlinkShow: boolean, appointment: server.dto.PlannerAppointment): boolean => {
  if (!canLinkUnlinkShow) {
    return false;
  }

  return appointment.type.value === "show";
}

const canLinkToShow = (canLinkUnlinkTravel: boolean, appointment: server.dto.PlannerAppointment): boolean => {
  if (!canLinkUnlinkTravel) {
    return false;
  }

  const appointmentType = appointment.type.value;
  return (appointmentType === "flight" ||
        appointmentType === "train" ||
        appointmentType === "groundTransport" ||
        appointmentType === "accommodation");
};

export type ItinerarySidebarItem = {
  type: server.dto.AppointmentTypes
  itemId: number
}

export type LinkedItineraryItems = {
  flightSegmentIds: number[]
  groundTransportIds: number[]
  trainSegmentIds: number[]
  showIds: number[]
}

export const isAppointmentLinked = (linkedItems: LinkedItineraryItems, appointment: server.dto.PlannerAppointment): boolean => {
  if (appointment.type.value === "flight" && linkedItems.flightSegmentIds.includes(appointment.flightSegmentId)) {
    return true;
  }

  if (appointment.type.value === "groundTransport" && linkedItems.groundTransportIds.includes(appointment.groundTransportId)) {
    return true;
  }

  if (appointment.type.value === "train" && linkedItems.trainSegmentIds.includes(appointment.trainSegmentId)) {
    return true;
  }

  if (appointment.type.value === "show" && linkedItems.showIds.includes(appointment.showId)) {
    return true;
  }

  if (appointment.type.value === "accommodation" && linkedItems.showIds.includes(appointment.showId)) {
    return true;
  }

  return false;
}